import moment from 'moment';
import {OrderAlgoType, parseAlgoTypeFromOrder} from '../../../../enums/order-algo-type';
import {NewOrder} from '../../../../models/order';
import {OrderTwapAlgoParams} from '../../../../models/order-algo-params';

export enum TwapAlgoParamsError {
    TWAP_TIME_IS_INVALID = 'TWAP_TIME_IS_INVALID'
}

export const getTwapAlgoParamsErrors = (newOrder: NewOrder): TwapAlgoParamsError[]  => {
    const errors: TwapAlgoParamsError[] = [];
    const algoType = parseAlgoTypeFromOrder(newOrder.algoType);

    if (algoType === OrderAlgoType.TWAP) {
        const algoParams = (newOrder.algoParams || {}) as OrderTwapAlgoParams;

        let isTimeRangeValid = !!algoParams.twapStartTime && !!algoParams.twapEndTime;

        if (isTimeRangeValid) {
            const mStartTime = moment(algoParams.twapStartTime);
            const mEndTime = moment(algoParams.twapEndTime);

            isTimeRangeValid = mStartTime.isBefore(mEndTime);
        }

        if (!isTimeRangeValid) {
            errors.push(TwapAlgoParamsError.TWAP_TIME_IS_INVALID);
        }
    }

    return errors;
};
